import { toast } from "react-toastify";

export const notify = (type, message) => {
  switch (type) {
    case "create":
      toast.success(message);
      break;
    case "update":
      toast.success(message);
      break;
    case "delete":
      toast.success(message);
      break;
    case "Error": // New error notification type
      toast.error(message);
      break;
    default:
      toast("Notification: " + message);
  }
};
